import React, { useEffect, useState } from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import Decrypt from "../../../shared/utils/Decrypt";
import axios from "axios";

import { div } from "three/src/nodes/math/OperatorNode.js";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter";
const InfoCard = ({
  isPOData,
  setPOData,
  isCampaignList = [],
  isViewMode,
  errors,
  listLoading,
}) => {
  const serverURL = process.env.REACT_APP_URL;

  const token = localStorage.getItem("token");
  const name = localStorage.getItem("name");
  const email = localStorage.getItem("email");
  const phoneNumber = localStorage.getItem("phoneNumber");
  const [vendors, setVendors] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [totalAreaByVendor, setTotalAreaByVendor] = useState("");

  const searchVendorApi = async (value) => {
    try {
      const response = await axios.get(
        `${serverURL}/api/getVendorsForPurchaseOrder`,
        {
          params: {
            search: value,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        setVendors(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchText.trim()) {
        searchVendorApi(searchText);
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [searchText]);

  const getVendorCampaignData = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/purchaseOrder/findTotalAreaByVendor`,
        {
          params: {
            vendorId: isPOData.vendorId,
            campaignId: isPOData.campaignId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setTotalAreaByVendor(response?.data?.totalArea || 0);

      // If you want to update PO data
      // setPOData(prev => ({
      //   ...prev,
      //   ...response.data.data,
      // }));
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (isPOData?.vendorId && isPOData?.campaignId) {
      getVendorCampaignData();
    }
  }, [isPOData?.vendorId, isPOData?.campaignId]);
  const selectedCampaign =
    isCampaignList.find((ele) => ele._id === isPOData?.campaignId) || null;

  const handleVendorChange = (event, value) => {
    const isIGST = value?.state !== "Haryana";

    setPOData((prev) => {
      const updatedItems = prev.productItems.map((item) => {
        const gstRate =
          Number(item.cgst || 0) +
          Number(item.sgst || 0) +
          Number(item.igst || 0);

        const taxable = Number(item.taxable || 0);

        const cgst = isIGST ? 0 : gstRate / 2;
        const sgst = isIGST ? 0 : gstRate / 2;
        const igst = isIGST ? gstRate : 0;

        const cgstAmount = (taxable * cgst) / 100;
        const sgstAmount = (taxable * sgst) / 100;
        const igstAmount = (taxable * igst) / 100;
        const cessAmount = (taxable * Number(item.cess || 0)) / 100;

        const total =
          taxable + cgstAmount + sgstAmount + igstAmount + cessAmount;

        return {
          ...item,
          cgst,
          sgst,
          igst,
          cgstAmount,
          sgstAmount,
          igstAmount,
          cessAmount,
          total,
        };
      });

      const poAmount = updatedItems.reduce(
        (sum, item) => sum + item.taxable,
        0,
      );

      const totalCGSTAmount = updatedItems.reduce(
        (sum, item) => sum + item.cgstAmount,
        0,
      );

      const totalSGSTAmount = updatedItems.reduce(
        (sum, item) => sum + item.sgstAmount,
        0,
      );

      const totalIGSTAmount = updatedItems.reduce(
        (sum, item) => sum + item.igstAmount,
        0,
      );

      const totalCESSAmount = updatedItems.reduce(
        (sum, item) => sum + item.cessAmount,
        0,
      );

      const totalTax = isIGST
        ? totalIGSTAmount + totalCESSAmount
        : totalCGSTAmount + totalSGSTAmount + totalCESSAmount;

      return {
        ...prev,
        vendorId: value?._id || "",
        vendorData: value,
        isIGST,
        productItems: updatedItems,

        poAmount,
        totalCGSTAmount,
        totalSGSTAmount,
        totalIGSTAmount,
        totalCESSAmount,
        totalTax,
        grandTotal: poAmount + totalTax,
      };
    });
  };
  const handleCampaignChange = (event, value) => {
    setPOData((prev) => ({
      ...prev,
      campaignId: value?._id || "",
      campaignData: value,
      locations: [],
    }));
  };
  const handleLocationSelect = (location) => {
    setPOData((prev) => {
      const alreadySelected = prev.locations?.includes(location);

      return {
        ...prev,
        locations: alreadySelected
          ? prev.locations.filter((loc) => loc !== location)
          : [...(prev.locations || []), location],
      };
    });
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 p-3 items-stretch bg-white">
      {" "}
      {/* Buyer */}
      <div className="h-full border-r border-gray-300 p-3">
        {" "}
        <h2 className="mb-4 font-bold text-[18px]">
          Name and Address of Buyer
        </h2>
        <div className="space-y-1 ">
          <p className="text-[18px] font-medium text-[#000000] leading-6">
            Signthought Solutions Private Limited
          </p>
          <p className="text-[18px] font-normal text-[#000000] leading-6">
            9, New Tikona Park, N.I.T, Faridabad (Haryana -6) India - 121001
          </p>

          <p className="text-[18px] font-medium text-[#000000] leading-6">
            Contact Person:{" "}
            <span className="text-[18px] font-normal text-[#000000] leading-6">
              {isPOData?.creator_first_name} {isPOData?.creator_last_name}
            </span>
          </p>
          <p className="text-[18px] font-medium text-[#000000] leading-6">
            Email:
            <span className="text-[18px] font-normal text-[#000000] leading-6">
              {isPOData?.creator_email}
            </span>
          </p>
          <p className="text-[18px] font-medium text-[#000000] leading-6">
            Contact No:
            <span className="text-[18px] font-normal text-[#000000] leading-6">
              {isPOData?.creator_contact_no}
            </span>
          </p>

          <p className="text-[18px] font-medium text-[#000000] leading-6">
            GSTIN:
            <span className="text-[18px] font-normal text-[#000000] leading-6">
              06ABOCS3601D1ZL
            </span>
          </p>

          <p className="text-[18px] font-medium text-[#000000] leading-6">
            Place of Supply:{" "}
            <span className="text-[18px] font-normal text-[#000000] leading-6">
              {`${isPOData?.place_city} ${isPOData?.place_state}(${isPOData?.place_state_code})`}
            </span>
          </p>
          {isPOData.vendorId && isPOData.campaignId && (
            <p className="text-[18px] font-medium text-[#000000] leading-6">
              Total Sq. ft. done by vendor:
              <span className="text-[18px] font-normal text-[#000000] leading-6">
                {totalAreaByVendor}
              </span>
            </p>
          )}
        </div>
      </div>
      {/* Supplier */}
      <div className="h-full border-r border-gray-300 p-3">
        {" "}
        <h2 className="mb-4 font-bold text-[18px]">
          Name and Address of Supplier
        </h2>
        {!isViewMode && (
          <Autocomplete
            options={vendors}
            filterOptions={(x) => x}
            openOnFocus
            value={isPOData?.supplier_company?.name}
            popupIcon={null} // Removes the dropdown icon
            onChange={handleVendorChange}
            onInputChange={(event, value) => {
              setSearchText(value);
            }}
            getOptionLabel={(option) => option?.vendorBusinessName || ""}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search supplier by name or mobile number"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <InputAdornment position="start">
                        <SearchIcon
                          fontSize="small"
                          className="text-gray-500"
                        />
                      </InputAdornment>
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option._id}>
                <div>
                  <p className="font-medium">{option.vendorBusinessName}</p>
                  <p className="text-xs text-gray-500">
                    {Decrypt(option.ownerPrimaryContactNo)}
                  </p>
                  <p className="text-xs text-gray-500">{option.city}</p>
                </div>
              </li>
            )}
          />
        )}
        {errors?.vendorId && (
          <p className="mt-1 text-sm text-red-500">{errors?.vendorId}</p>
        )}
        {isPOData?.supplier_company?.name && (
          <div className="mt-2  bg-white ">
            <p className="text-[18px] font-medium text-[#000000] leading-6">
              {isPOData?.supplier_company?.name}
            </p>

            <div className=" gap-x-3 gap-y-1 text-xs">
              <div className="col-span-2">
                <p className="text-[18px] leading-6">
                  <p className="text-[18px] font-medium text-[#000000] leading-6">
                    Address:
                    <span className="text-[18px] font-normal text-[#000000] leading-6">
                      {" "}
                      {isPOData?.to_company_address1},{" "}
                      {isPOData?.to_company_city}, {isPOData?.to_company_state}{" "}
                      - {isPOData?.to_company_pin}{" "}
                    </span>
                  </p>
                </p>
              </div>
              {isPOData?.open_text_field && (
                <p className="text-[18px] font-medium text-[#000000] leading-6">
                  Contact Person:
                  <span className="text-[18px] font-normal text-[#000000] leading-6">
                    {" "}
                    {isPOData?.open_text_field || "-"}
                  </span>
                </p>
              )}

              <p className="text-[18px] font-medium text-[#000000] leading-6">
                Contact no.:{" "}
                <span className="text-[18px] font-normal text-[#000000] leading-6">
                  {isPOData?.to_company_contact_no || "-"}
                </span>
              </p>

              <p className="text-[18px] font-medium text-[#000000] leading-6">
                Email:{" "}
                <span className="text-[18px] font-normal text-[#000000] leading-6">
                  {isPOData?.to_company_email || "-"}
                </span>
              </p>

              <p className="text-[18px] font-medium text-[#000000] leading-6">
                GSTIN:{" "}
                <span className="text-[18px] font-normal text-[#000000]">
                  {" "}
                  {isPOData?.to_company_address_gstin || "-"}
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
      {/* Shipping */}
      <div className="h-full p-3 ">
        {" "}
        <h2 className="mb-4 font-bold text-[18px]">Shipping Details</h2>
        {!isViewMode && (
          <>
            <Autocomplete
              options={isCampaignList}
              value={selectedCampaign}
              onChange={handleCampaignChange}
              getOptionLabel={(option) => option?.campaignTitle || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search Shipping"
                  size="small"
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option._id}>
                  <div className="w-full  border border-1 py-1 px-1 rounded-md">
                    <p className="font-medium text-gray-800">
                      {option.campaignTitle}
                    </p>

                    <div className="mt-2 flex flex-wrap gap-1">
                      {option.locations?.slice(0, 4).map((location, index) => (
                        <span
                          key={index}
                          className="
            rounded-full
            bg-blue-50
            px-2
            py-0.5
            text-[11px]
            font-medium
            text-blue-700
          "
                        >
                          {location}
                        </span>
                      ))}

                      {option.locations?.length > 4 && (
                        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] text-gray-600">
                          +{option.locations.length - 4} more
                        </span>
                      )}
                    </div>
                  </div>
                </li>
              )}
            />
            {errors.locations && (
              <p className="mt-1 text-sm text-red-500">{errors.locations}</p>
            )}
          </>
        )}
        <div
          className="
      mt-1 rounded-2xl bg-white p-1
     transition-all duration-300
      
    "
        >
          {/* Locations */}

          <div className="  gap-2">
            {isViewMode ? (
              <>
                <>
                  <p className="text-[18px] font-medium text-[#000000] leading-6">
                    {isPOData?.delivery_location_name}
                  </p>
                  <p className="text-[18px] font-normal text-[#000000] leading-6">
                    {isPOData?.delivery_location_address1}
                  </p>
                  <p className="text-[18px] font-normal text-[#000000] leading-6">
                    {isPOData?.delivery_location_address2},{" "}
                    {isPOData?.delivery_location_city},{" "}
                    {isPOData?.delivery_location_state}
                  </p>
                  <p className="text-[18px] font-normal text-[#000000] leading-6">
                    {isPOData?.delivery_location_country}-
                    {isPOData?.delivery_location_pin}
                  </p>
                  <div></div>
                  <p className="text-[18px] font-medium text-[#000000] leading-6">
                    GSTIN:
                    <span className="text-[18px] font-normal text-[#000000] leading-6">
                      {isPOData?.delivery_location_gstin}{" "}
                    </span>
                  </p>
                </>

                {isPOData?.locations?.map((location, index) => (
                  <p
                    key={index}
                    className="text-[18px] font-normal text-[#000000] leading-6"
                  >
                    {location}
                  </p>
                ))}
              </>
            ) : listLoading ? (
              <div className="w-full h-full flex items-center justify-center mt-4">
                <CircularProgress />
              </div>
            ) : (
              selectedCampaign && (
                <div className="">
                  <p className="font-medium text-[14px] text-blue-500">
                    Select Locations:
                  </p>
                  <div className="h-[150px] w-[350px] overflow-y-auto  bg-white p-3">
                    <div className="flex flex-wrap gap-2">
                      {selectedCampaign.locations.map((location, index) => {
                        const isSelected =
                          isPOData?.locations?.includes(location);

                        return (
                          <button
                            key={index}
                            type="button"
                            onClick={() => handleLocationSelect(location)}
                            className={`
              rounded-full border px-4 py-2 text-xs font-medium transition-all duration-200
            ${
              isSelected
                ? "border-blue-600 bg-blue-600 text-white shadow-sm"
                : "border-gray-300 bg-gray-50 text-gray-700 hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700"
            }
          `}
                          >
                            {location}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
